
import React, { useState, useEffect } from 'react'
import { AiOutlinePlusCircle, AiOutlineDelete } from 'react-icons/ai';
import axios from 'axios'
import { useNavigate } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';
import ToastNotification from '../../../components/ToastNotification';
import { MdEdit } from "react-icons/md";
import { useLoading } from '../../../context/LoadingContext';
import { useLocation } from 'react-router-dom';


function CustomareCareDetail({ adminData }) {
    const location = useLocation();


    const mode = location.state?.mode;
    const partyId = location.state?.partyId;


    const navigate = useNavigate();
    const { setLoading } = useLoading();
    const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
    const showToast = (msg, bg = 'success') => {
        setToast({ show: true, message: msg, bg });
    };
    const [formItems, setFormItems] = useState({
        id: "",
        holder_name: "",
        code: "",
        party_mobile: "",
        party_email: "",
        party_birth_day: "",
        party_region: "",
        party_address: "",
        op_bal: "",
        budget: "",
        days: "",
        type_account: "",
        parent: "",
        remark: '',
    });

    const [searchTerm, setSearchTerm] = useState('');
    const [isEditMode, setIsEditMode] = useState(false);
    const [showAddForm, setShowAddForm] = useState(false);
    const [accountDetail, setAccountDetail] = useState([]);
    const [editingCompanyId, setEditingCompanyId] = useState(null);
    const [quotation, setQuotation] = useState([]);
    const [fetchSale, setFetchSale] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [currentPartyId, setCurrentPartyId] = useState(null);
    const [selectedAccount, setSelectedAccount] = useState(null);
    const [selectedParty, setSelectedParty] = useState("");
    const [fetchReturn, setFetchReturn] = useState([]);
    const [fetchChallan, setFetchChallan] = useState([]);
    const [saleReturnRefDocs, setSaleReturnRefDocs] = useState([]);
    const [amc, setAmc] = useState([]);
    const [fetchWarranty, setFetchWaranty] = useState([]);
    const [order, setOrder] = useState([]);
    const [purchaseQuotation, setPurchaseQuotation] = useState([]);
    const [purchase, setPurchase] = useState([]);
    const [fetchPruchaseReturn, setFetchPurchaseReturn] = useState([]);
    const [purchaseTableData, setPurchaseTableData] = useState([]);
    const [callList, setCallList] = useState([]);
    const [fetchPms, setFetchPms] = useState([]);
    const [unifiedTableData, setUnifiedTableData] = useState([]);


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormItems(prev => ({
            ...prev,
            [name]: value
        }));
    };


    useEffect(() => {
        if (mode === "isEditMode" && partyId) {
            setIsEditMode(true);
            setEditingCompanyId(partyId);
            fetchPartyData(partyId)
            setShowAddForm(true);
        }
    }, [mode, partyId]);

    const fetchPartyData = async (partyId) => {
        try {
            const res = await axios.get(`/api/customer-care/${partyId}`);
            const party = res.data.party;
            setFormItems({
                id: party.id,
                holder_name: party.holder_name,
                code: party.code,
                party_mobile: party.party_mobile,
                party_email: party.party_email,
                party_birth_day: party.party_birth_day,
                party_region: party.party_region,
                party_address: party.party_address,
                op_bal: party.op_bal,
                budget: party.budget,
                days: party.days,
                type_account: party.type_account,
                parent: party.parent
            });


            setPurchaseTableData(res.data.purchases);
            setUnifiedTableData(res.data.followups);
            //   setRemarksHistory(res.data.remarks);

        } catch (err) {
            console.error(err);
        }
    };


    const normalizeItems = (items) => {
        if (!items) return [];
        if (Array.isArray(items)) return items;
        if (typeof items === "string") {
            try {
                const parsed = JSON.parse(items);
                return Array.isArray(parsed) ? parsed : [];
            } catch (e) {
                console.error("Invalid items JSON:", items);
                return [];
            }
        }

        return [];
    };

    const remarksHistory = selectedAccount?.remarks_history || [];
    const userId = adminData.user.id


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isEditMode) {
            try {
                await axios.put(
                    `https://api.skyguard.group/api/update-account-remark/${formItems.id}`,
                    {
                        remark: formItems.remark,
                        added_by: userId
                    }
                );

                showToast('Remark added successfully!', 'success');
                fecthAccountDetail();
                setShowAddForm(false);
            } catch (error) {
                console.error("❌ Remark update failed:", error);
                showToast('Fail to update remark!', 'danger');
            }
        }
    };


    const handleEdit = (form) => {
        setFormItems({
            id: form.id || "",
            holder_name: form.holder_name || "",
            code: form.code || "",
            party_mobile: form.party_mobile || "",
            party_email: form.party_email || "",
            party_birth_day: form.party_birth_day || "",
            party_region: form.party_region || "",
            party_address: form.party_address || "",
            op_bal: form.op_bal || "",
            budget: form.budget || "",
            days: form.days || "",
            type_account: form.type_account || "",
            parent: form.parent || ""
        });
        setSelectedAccount(form);
        setEditingCompanyId(form.id);
        setIsEditMode(true);
        setShowAddForm(true);
        setCurrentPartyId(form.id);
    };



    const handleRedirect = (row) => {

        
    switch (row.source) {
        case "Quotation":
            navigate(`/admin/sale-quotation`,{
                state: { data: row.fullData, mode: "edit" }
            });
            break;
        case "Invoice":
            navigate(`/admin/sale-invoice`,{
                state: { data: row.fullData, mode: "edit" }
            });
            break;
        case "Delivery Challan":
            navigate(`/admin/delivery-challan`,{
                state: { data: row.fullData, mode: "edit" }
            });
            break;
        case "Sale Return":
            navigate(`/admin/sale-return`,{
                state: { data: row.fullData, mode: "edit" }
            });
            break;
        case "AMC":
            navigate(`/admin/amc`,{
                state: { data: row.fullData, mode: "edit" }
            });
            break;
        case "Warranty":
            navigate(`/addmin/warranty`,{
                state: { data: row.fullData, mode: "edit" }
            });
            break;
        default:
            console.log("Unknown type");
    }
};


    const handleRedirectPurchase = (row) => {

        console.log(row);
   
    switch (row.source) {
        case "Purchase Quotation":
            navigate(`/admin/quotation`,{
                state: { data: row.fullData, mode: "edit" }
            });
            break;
        case "Order":
            navigate(`/admin/order`,{
                state: { data: row.fullData, mode: "edit" }
            });
            break;
        case "Purchase":
            navigate(`/admin/purchase`,{
                state: { data: row.fullData, mode: "edit" }
            });
            break;
        case "Purchase Return":
            navigate(`/admin/purchase-return`,{
                state: { data: row.fullData, mode: "edit" }
            });
            break;
        default:
            console.log("Unknown type");
    }
};

    const handleRedirectCall = (row) => {  
    
    switch (row.source) {
        case "Complaint":
              navigate(`/admin/crm/complaint`, {
                state: { data: row.fullData, mode: "edit" }
            });
            break;
        case "PMS":
             navigate(`/admin/generate-pms`, {
                state: { data: row.fullData, mode: "edit" }
            });
            break;
        default:
            console.log("Unknown type");
    }
};



    const fecthAccountDetail = async () => {
        try {
            const resParty = await axios.get('https://api.skyguard.group/api/fetch-account');
            const result = resParty.data.result;
            // setParent(result);
            setAccountDetail(result);
            console.log(result);

        } catch (error) {
            console.log(error)
        }
    };

    const fetchSaleQuotation = async (partyId) => {
        setLoading(true);
        try {
            const response = await axios.get('https://api.skyguard.group/api/fetch-sale-quotation');
            const filtered = response.data.filter(doc => Number(doc.party) === Number(partyId));
            setQuotation(filtered);

            // build table immediately after fetching quotation
            setTableData(buildTableData(filtered, fetchSale, partyId));

            console.log('SALE QUOTATION RESPONSE', filtered);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const fetchSaleInvoice = async (partyId) => {
        setLoading(true);
        try {
            const response = await axios.get('https://api.skyguard.group/api/fetch-sale-invoice');
            const filtered = response.data.filter(
                item => item.type_acc === "sale_invoice" && Number(item.party) === Number(partyId)
            );
            setFetchSale(filtered);


            setTableData(buildTableData(quotation, filtered, partyId));

            console.log('SALE INVOICE RESPONSE', filtered);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    //add more api 
    const fetchDeliveryChallan = async () => {
        setLoading(true)
        try {
            const response = await axios.get(
                'https://api.skyguard.group/api/fetch-delivery-challan'
            );

            // ✅ filter only delivery challan
            const deliveryChallanOnly = response.data.filter(
                item => item.type_acc === "delivery_challan"
            );

            setFetchChallan(deliveryChallanOnly);

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const fetchSaleReturn = async () => {
        try {
            const response = await axios.get(
                'https://api.skyguard.group/api/fetch-sale-return'
            );

            const saleReturnOnly = response.data.filter(
                item => item.type_acc === "sale_return"
            );

            const returnRefDocs = saleReturnOnly
                .map(item => String(item.ref_doc_sq ?? item.ref_doc))
                .filter(Boolean); // remove null/undefined

            setSaleReturnRefDocs(returnRefDocs);
            setFetchReturn(saleReturnOnly);
        } catch (error) {
            console.log(error);
        }
    };

    const fetchAmc = async () => {
        setLoading(true)
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-amc');
            setAmc(res.data)
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    const fetchWarrantyDetail = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                "https://api.skyguard.group/api/fetch-warranty"
            );


            const filterWarranty = response.data.filter(r => r.type_acc === 'warranty')
            setFetchWaranty(filterWarranty);


        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };



    const buildRefDoc = (doc, source) => {
        const branch = doc.branch || doc.branchId || "";

        switch (source) {
            case "Quotation":
                return `SQ/${doc.inv_no}/${branch}`;

            case "Invoice":
                return `SI/${doc.inv_no}/${branch}`;

            case "Delivery Challan":
                return `DC/${doc.inv_no}/${branch}`;

            case "Sale Return":
                return `SR/${doc.inv_no}/${branch}`;

            case "AMC":
                return `AMC/${doc.id}/${branch}`;

            case "Warranty":
                return `WR/${doc.id}/${branch}`;

            default:
                return "-";
        }
    };


    const buildTableData = (
        quotation = [],
        invoice = [],
        deliveryChallan = [],
        saleReturn = [],
        amc = [],
        warranty = [],
        selectedParty = ""
    ) => {
        const rowsFromDocs = (docs, typeField, sourceName) =>
            docs.flatMap(doc => {
                if (Number(doc.party) !== Number(selectedParty)) return [];
                const items = normalizeItems(doc.items || []);
                return items.map(item => ({
                    refDoc: buildRefDoc(doc, sourceName),
                    billDate: doc.created_date || doc.created_at || "-",
                    partyName: doc.party_name || "-",
                    itemName: item.name || "-",
                    qty: item.qty || 0,
                    rate: item.rate || 0,
                    amount: item.amount || 0,
                    source: sourceName,

                      fullData: doc,  
            fullItem: item 

                    
                }));
            });

        return [
            ...rowsFromDocs(quotation, "ref_no", "Quotation"),
            ...rowsFromDocs(invoice, "invoice_no", "Invoice"),
            ...rowsFromDocs(deliveryChallan, "challan_no", "Delivery Challan"),
            ...rowsFromDocs(saleReturn, "ref_doc", "Sale Return"),
            ...rowsFromDocs(amc, "amc_no", "AMC"),
            ...rowsFromDocs(warranty, "warranty_no", "Warranty")
        ];


    };





    useEffect(() => {


        const merged = buildTableData(
            quotation,
            fetchSale,
            fetchChallan,
            fetchReturn,
            amc,
            fetchWarranty,
            selectedParty
        );

        setTableData(merged);
    }, [
        quotation,
        fetchSale,
        fetchChallan,
        fetchReturn,
        amc,
        fetchWarranty,
        selectedParty
    ]);


    //purchase api

    const fetchOrderDetail = async () => {
        setLoading(true);
        try {
            const resPurchase = await axios.get("https://api.skyguard.group/api/fetch-order-detail");

            const data = Array.isArray(resPurchase.data)
                ? resPurchase.data
                : resPurchase.data?.data || [];

            const orderOnly = data.filter(item => item.type_acc === "Order");

            setOrder(orderOnly);

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const fetchPurchaseQuoationDetail = async () => {
        setLoading(true);
        try {
            const resPurchase = await axios.get("https://api.skyguard.group/api/fetch-quotation-detail");


            const quotationsOnly = (resPurchase.data || []).filter(
                (item) => item.type_acc === "Quotation"
            );

            setPurchaseQuotation(quotationsOnly);

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const fetchPurchaseDetail = async () => {
        setLoading(true);
        try {
            const resPurchase = await axios.get("https://api.skyguard.group/api/fetch-purchase");

            const data = Array.isArray(resPurchase.data)
                ? resPurchase.data
                : resPurchase.data?.data || [];

            const purchaseOnly = data.filter(item => item.type_acc === "Purchase");

            setPurchase(purchaseOnly)

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const fetchPurchaseReturn = async () => {
        setLoading(true);
        try {
            const resPurchase = await axios.get("https://api.skyguard.group/api/fetch-purchase-return");

            const data = Array.isArray(resPurchase.data)
                ? resPurchase.data
                : resPurchase.data?.data || [];

            const returnOnly = data.filter(item => item.type_acc === "Return");

            setFetchPurchaseReturn(returnOnly)


        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const buildPurchaseRefDoc = (doc, source) => {
        const branch = doc.branch || doc.branchId || "";

        switch (source) {
            case "Order":
                return `PO/${doc.inv_no}/${branch}`;

            case "Purchase Quotation":
                return `PQ/${doc.inv_no}/${branch}`;

            case "Purchase":
                return `PU/${doc.inv_no}/${branch}`;

            case "Purchase Return":
                return `PR/${doc.inv_no}/${branch}`;

            default:
                return "-";
        }
    };

    const buildPurchaseTableData = (
        order = [],
        purchaseQuotation = [],
        purchase = [],
        purchaseReturn = [],
        selectedParty = ""
    ) => {
        // helper to map docs to table rows
        const rowsFromDocs = (docs, typeField, sourceName) =>
            (Array.isArray(docs) ? docs : []).flatMap(doc => {
                if (Number(doc.party) !== Number(selectedParty)) return [];
                const items = normalizeItems(doc.items || []);
                return items.map(item => ({
                    refDoc: buildPurchaseRefDoc(doc, sourceName) || "-",
                    billDate: doc.date || "-",
                    partyName: doc.party_name || "-",
                    itemName: item.name || "-",
                    qty: item.qty || 0,
                    rate: item.rate || 0,
                    amount: item.amount || 0,
                    source: sourceName,

                       fullData: doc 
                }));
            });


        return [
            ...rowsFromDocs(order, "order_no", "Order"),
            ...rowsFromDocs(purchaseQuotation, "ref_no", "Purchase Quotation"),
            ...rowsFromDocs(purchase, "purchase_no", "Purchase"),
            ...rowsFromDocs(purchaseReturn, "ref_doc", "Purchase Return")
        ];


    };



    useEffect(() => {
        if (!selectedParty) return;

        const merged = buildPurchaseTableData(
            order,
            purchaseQuotation,
            purchase,
            fetchPruchaseReturn,
            selectedParty
        );

        setPurchaseTableData(merged);
    }, [
        order,
        purchaseQuotation,
        purchase,
        fetchPruchaseReturn,
        selectedParty
    ]);


    //api for call 
    const fetchComplaints = async () => {
        try {
            const res = await axios.get("https://api.skyguard.group/api/fetch-complaint");
            setCallList(res.data);
        } catch (err) {
            console.error(err);
        }
    };


    const fetchPmsDetail = async () => {
        setLoading(true);
        try {
            const res = await axios.get(
                "https://api.skyguard.group/api/fetch-pms-schedules"
            );

            const parsedData = res.data
                .filter(row => row.status.toLowerCase() !== "completed oc")
                .map(row => ({
                    ...row,
                    items:
                        typeof row.items === "string"
                            ? JSON.parse(row.items)
                            : row.items || [],
                    remark_history:
                        typeof row.remark_history === "string"
                            ? JSON.parse(row.remark_history)
                            : row.remark_history || []
                }));

            setFetchPms(parsedData);

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const buildServiceRefDoc = (row, source) => {
        const branch = row.branch || row.branchId || "";

        switch (source) {
            case "PMS":

                return `PMS/${row.id}/${branch}`;

            case "Complaint":
                // example: CMP/00045/BR01
                return `CMP/${row.ref_doc}/${branch}`;

            default:
                return "-";
        }
    };


    const buildUnifiedTableData = (pmsData = [], complaintsData = [], selectedParty = "") => {

        const pmsRows = (Array.isArray(pmsData) ? pmsData : []).flatMap(row => {
            if (selectedParty && Number(row.party) !== Number(selectedParty)) return [];

            return (row.items || []).map(item => ({
                refDoc: row.ref_doc || "-",
                date: row.date || row.created_at || "-",
                partyName: row.party_name || "-",
                itemName: item.name || item.description || "-",
                qty: item.qty || 0,
                status: row.status || "-",
                remarks: row.remark_history || [],
                source: "PMS",

             fullData: row 
            }));
        });



        const complaintRows = (Array.isArray(complaintsData) ? complaintsData : []).flatMap(row => {

            if (selectedParty && Number(row.partyid) !== Number(selectedParty)) return [];

            const items =
                typeof row.items === "string"
                    ? JSON.parse(row.items)
                    : Array.isArray(row.items)
                        ? row.items
                        : [];

            if (items.length === 0) {
                return [{
                    refDoc: buildServiceRefDoc(row, 'Complaint') || "-",
                    date: row.date || "-",
                    partyName: row.party_name || "-",
                    itemName: row.subject || row.description || "-",
                    qty: "-",
                    status: row.status || "-",
                    remarks: row.remark_history || [],
                    source: "Complaint"
                }];
            }

            return items.map(item => ({
                refDoc: buildServiceRefDoc(row, 'Complaint') || "-",
                date: row.date || "-",
                partyName: row.party_name || "-",
                itemName: item.name || item.description || "-",
                qty: item.qty || "-",
                status: row.status || "-",
                remarks: row.remark_history || [],
                source: "Complaint",

               fullData: row 
            }));
        });


        return [...pmsRows, ...complaintRows];
    };


    useEffect(() => {
        if (!selectedParty) return;

        const mergedTable = buildUnifiedTableData(fetchPms, callList, selectedParty);
        console.log("Merged PMS + Complaints Table:", mergedTable);
        setUnifiedTableData(mergedTable);
    }, [fetchPms, callList, selectedParty]);





    useEffect(() => {
        fecthAccountDetail();
        fetchSaleQuotation();
        fetchSaleInvoice();
        fetchDeliveryChallan();
        fetchSaleReturn();
        fetchAmc();
        fetchWarrantyDetail();


        fetchOrderDetail();
        fetchPurchaseDetail();
        fetchPurchaseQuoationDetail();
        fetchPurchaseReturn();

        fetchComplaints();;
        fetchPmsDetail();

    }, []);


    const filterAccount = accountDetail.filter((tt) => {
        const term = (searchTerm || "").toLowerCase();

        return (
            (tt.holder_name && tt.holder_name.toLowerCase().includes(term)) ||
            (tt.type_account && tt.type_account.toLowerCase().includes(term)) ||
            (tt.code && tt.code.toLowerCase().includes(term)) ||
            (tt.party_phone && tt.party_phone.toLowerCase().includes(term)) ||
            (tt.party_mobile && tt.party_mobile.toLowerCase().includes(term)) ||
            (tt.phone_two && tt.phone_two.toLowerCase().includes(term)) ||
            (tt.phone_three && tt.phone_three.toLowerCase().includes(term))
        );
    });

    return (
        <div className='main-section'>
            <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                <h3 className='my-3 fw-bold fs-5 golos'>Customer Details</h3>
                <ToastNotification
                    show={toast.show}
                    message={toast.message}
                    bg={toast.bg}
                    onClose={() => setToast({ ...toast, show: false })}
                />
                <div className="mb-3 row gx-2 gy-2 d-flex justify-content-between">


                    <div class="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-between">

                        <div class="col-12 col-md-9">
                            <div className="row my-3 align-items-center">
                                {/* Input */}
                                <div className="col-md-4">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search By name,type number"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-2 d-flex justify-content-end">
                            <button
                                className={`btn ${showAddForm ? 'btn-danger' : 'btn-success'}`}
                                onClick={() => {
                                    setShowAddForm(!showAddForm);
                                    if (showAddForm) {

                                    }
                                }}
                            >
                                {showAddForm ? 'Cancel' : 'Add'}{' '}
                                {showAddForm ? <FaTimes size={18} /> : <AiOutlinePlusCircle size={20} />}
                            </button>
                        </div>

                    </div>
                </div>

                {showAddForm && (
                    <div className='card p-3 mb-4'>


                                              {isEditMode && (
  <div className="mb-3">
    {/* <label>Company  Name:</label> <br /> */}
    <span className="badge bg-primary px-3 py-2">
     {formItems.code}
    </span>
  </div>
)}

                        <form className='row g-3' onSubmit={handleSubmit} >
                            <div className='col-md-4'>
                                <label className='form-label fw-medium'> Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="holder_name"
                                    value={formItems.holder_name}
                                    onChange={handleInputChange}
                                    disabled={isEditMode}
                                />
                            </div>

                            <div className="col-md-4">
                                <laebl className='form-label fw-medium'>Account Code</laebl>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="code"
                                    value={formItems.code}
                                    onChange={handleInputChange}
                                    disabled={isEditMode}
                                />
                            </div>
                            <div className="col-md-4">
                                <laebl className='form-label fw-medium'>Phone No.</laebl>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="party_mobile"
                                    value={formItems.party_mobile}
                                    onChange={handleInputChange}
                                    disabled={isEditMode}
                                />

                            </div>
                            <div className="col-md-4">
                                <laebl className='form-label fw-medium'>Email</laebl>
                                <input
                                    type="email"
                                    className="form-control"
                                    name="party_email"
                                    value={formItems.party_email}
                                    onChange={handleInputChange}
                                    disabled={isEditMode}
                                />
                            </div>
                            <div className="col-md-4">
                                <laebl className='form-label fw-medium'>Date Of Birth</laebl>
                                <input
                                    type="date"
                                    className="form-control"
                                    name="party_birth_day"
                                    value={formItems.party_birth_day}
                                    onChange={handleInputChange}
                                    disabled={isEditMode}
                                />

                            </div>
                            <div className="col-md-4">
                                <laebl className='form-label fw-medium'>Region</laebl>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="party_region"
                                    value={formItems.party_region}
                                    onChange={handleInputChange}
                                    disabled={isEditMode}
                                />

                            </div>

                            <div className="col-md-4" style={{ display: 'flex', flexDirection: 'column' }}>
                                <label className="form-label fw-medium">Register New Call</label>

                                <button
                                    type="button"
                                    className="btn btn-info"
                                    onClick={() =>
                                        navigate("/admin/crm/complaint", {
                                            state: {
                                                showAddForm: true,
                                                partyData: {
                                                    partyid: formItems.id,
                                                    party: formItems.holder_name,
                                                    site: formItems.party_address,
                                                    contact_no: formItems.party_mobile
                                                }
                                            }
                                        })
                                    }
                                >
                                    Click Here
                                </button>

                            </div>
                            <div className="col-md-4">
                                <laebl className='form-label fw-medium' >Address</laebl>
                                <textarea
                                    rows={4}
                                    className="form-control"
                                    name="party_address"
                                    value={formItems.party_address}
                                    onChange={handleInputChange}
                                    disabled={isEditMode}
                                />
                            </div>
                            <div className="col-md-4">
                                <laebl className='form-label fw-medium'>Remark</laebl>
                                <textarea
                                    rows={4}
                                    className="form-control"
                                    name="remark"
                                    value={formItems.remark}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="table-responsive">

                                <table className="table table-bordered text-center align-middle" >
                                    <thead className="table-dark">
                                        <tr>
                                            <th scope='col'>Ref Doc</th>
                                            <th scope='col'>Bill Date</th>
                                            <th scope='col'>Branch</th>
                                            <th scope='col'>Item Name</th>
                                            <th scope='col'>Qty</th>
                                            <th scope='col'>Rate</th>
                                            <th scope='col'>Amount</th>
                                            <th scope='col'>Bill Type </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {tableData.map((row, index) => (
                                            <tr key={index}>
                                                {/* <td>{row.refDoc}</td> */}

                                                <td>                                          <span
        style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
        onClick={() => handleRedirect(row)}
    >
        {row.refDoc}
    </span> </td>
       
                                                <td>{row.billDate}</td>
                                                {/* <td>{row.parentName}</td> */}
                                                <td>{row.partyName} </td>
                                                <td>{row.itemName}</td>
                                                <td>{row.qty}</td>
                                                <td>{row.rate}</td>
                                                <td>{row.amount}</td>
                                                <td>
                                                    <span className={`badge ${row.source === "Invoice" ? "bg-success" : "bg-primary"}`}>
                                                        {row.source}
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>


                            <div className='table-responsive' >
                                <h3>Purchase History </h3>
                                <table className="table table-bordered text-center align-middle">
                                    <thead className='table-dark'>
                                        <tr>
                                            <th>Ref Doc</th>
                                            <th>Bill Date</th>
                                            <th>Party Name</th>
                                            <th>Item Name</th>
                                            <th>Qty</th>
                                            <th>Rate</th>
                                            <th>Amount</th>
                                            <th scope='col'>Source</th>
                                        </tr>
                                    </thead >
                                    <tbody>
                                        {purchaseTableData.map((row, idx) => (
                                            <tr key={idx}>
                                                {/* <td>{row.refDoc}</td> */}
                            <td>                                          <span
        style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
        onClick={() => handleRedirectPurchase(row)}
    >
        {row.refDoc}
    </span> </td>
                                                <td>{row.billDate}</td>
                                                <td>{row.partyName}</td>
                                                <td>{row.itemName}</td>
                                                <td>{row.qty}</td>
                                                <td>{row.rate}</td>
                                                <td>{row.amount}</td>
                                                <span className={`badge text-white mt-1 ${row.source === "Purchase" ? "bg-success" : "bg-primary"}`}>
                                                    {row.source}
                                                </span>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                            </div>

                            <div className='table-responsive'>
                                <h3>Call History</h3>
                                <table className="table table-bordered text-center align-middle">
                                    <thead className='table-dark'>
                                        <tr>
                                            <th>Ref</th>
                                            <th>Date</th>
                                            <th>Party</th>
                                            <th>Item</th>


                                            <th>Source</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {unifiedTableData.map((row, index) => (
                                            <tr key={index}>
                                                {/* <td>{row.refDoc}</td> */}
                                                                                  <td>                                          <span
        style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
        onClick={() => handleRedirectCall(row)}
    >
        {row.refDoc}
    </span> </td>
                                                <td>{row.date}</td>
                                                <td>{row.partyName}</td>
                                                <td>{row.itemName}</td>


                                                <span className={`badge text-white mt-1 ${row.source === "Complaint" ? "bg-success" : "bg-primary"}`}>
                                                    {row.source}
                                                </span>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                            </div>


                            <div className='table-responsive' >
                                <h3 className='fw-medium'> Remark History</h3>
                                <table className="table table-bordered text-center align-middle">
                                    <thead className='table-dark'>
                                        <tr>
                                            <th>SN</th>
                                            <th>Added By</th>
                                            <th>Date</th>
                                            <th>Remark</th>

                                        </tr>
                                    </thead>

                                    <tbody>
                                        {remarksHistory.length > 0 ? (
                                            remarksHistory.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.added_by}</td>
                                                    <td>{new Date(item.created_at).toLocaleString()}</td>
                                                    <td>{item.remark}</td>


                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="4" className="text-center">
                                                    No remarks history found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                            </div>




                            <div className="col-md-12 d-grid d-flex justify-content-center gap-2">

                                <button type="submit" className='btn btn-success w-10 '>
                                    {isEditMode ? "Update" : "Save"}
                                </button>
                                <button type='button' className='btn btn-danger ' onClick={() => {
                                    setShowAddForm(false);
                                    setIsEditMode(false);

                                }}>
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </div>
                )}

                <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                    <table className='table table-bordered table-striped table-hover text-center align-middle'>
                        <thead className='table-info'>
                            <tr>
                                <th scope='col'>SN</th>
                                <th scope='col'>Action</th>
                                <th scope='col'> Name</th>
                                <th scope='col'>Code</th>

                                <th scope='col'> Account Type </th>

                            </tr>
                        </thead>
                        <tbody>

                            {filterAccount.length > 0 ? (
                                filterAccount.map((acc, idx) => {
                                    const parentObj = accountDetail.find(a => String(a.id) === String(acc.parent));
                                    const parentName = parentObj ? parentObj.holder_name : "-";
                                    return (
                                        <tr key={idx}>
                                            <td>{idx + 1}</td>
                                            <td>
                                                <button
                                                    className="btn btn-success mx-2"
                                                    onClick={() =>
                                                        navigate("/admin/party", {
                                                            state: {
                                                                mode: "isEditMode",
                                                                partyId: acc.party_id,
                                                            },
                                                        })
                                                    }
                                                >
                                                    View Party
                                                </button>



                                                <button className='btn btn-primary mx-2' type='button'
                                                    onClick={() => {
                                                        setSelectedParty(acc.party_id);
                                                        setSelectedAccount(acc);
                                                        handleEdit(acc)

                                                        fetchSaleQuotation(acc.party_id)
                                                        fetchSaleInvoice(acc.party_id)

                                                        fetchOrderDetail();
                                                        fetchPurchaseQuoationDetail();
                                                        fetchPurchaseDetail();
                                                        fetchPurchaseReturn();



                                                    }}
                                                >
                                                    Edit
                                                </button>


                                            </td>
                                            <td>{acc.holder_name}</td>
                                            <td>{acc.code}</td>

                                            <td>{acc.type_account} </td>

                                        </tr>
                                    )
                                })
                            ) : (
                                <tr>
                                    <td colSpan="7">No data found.</td>
                                </tr>
                            )}

                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    )
}

export default CustomareCareDetail




